var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'f-progress-bar': true,
    'is-complete': _vm.progress === Number(100)
  }},[_c('div',{staticClass:"f-progress-bar-line"},[_c('div',{staticClass:"f-progress-bar-line-completion",style:('width: ' + _vm.progress + '%;')})]),_c('div',{staticClass:"f-progress-bar-value"},[_vm._v(_vm._s(_vm.progress)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }